import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { trims } from '../../../../reducers/trims/selectors';
import combineSelectors from 'utils/combineSelectors';
import { addProps, addIntlProps } from 'utils/recompose';
import messages from '../messages';
import { getDropdownOptions } from '../enhance';

const mapStateToProps = combineSelectors({
  trims,
});

const options = ({ trims, availableOptions }) =>
  getDropdownOptions(trims, availableOptions);

export default compose(
  injectIntl,
  addIntlProps({ messages, propNames: ['trimFormPlaceHolder'] }),
  connect(mapStateToProps),
  addProps({ options }),
);
